import React, { Component } from "react";
import { connect } from "react-redux";

import { setCurrentTheme } from "../actions/themeActions";

class ThemeSwitch extends Component {
  componentDidMount() {
    const { theme, setTheme } = this.props;
    setTheme(theme);
    const mainBody = document.getElementById("mainBody");
    if (theme) mainBody.classList.add(`theme-${theme}`);
  }

  render() {
    return <>{this.props.children}</>;
  }
}

const mapDispatchToProps = {
  setTheme: setCurrentTheme,
};

export default connect(null, mapDispatchToProps)(ThemeSwitch);
